var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPieChart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ico_pie_chart",
    transform: "translate(49 -7.688)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Canvas",
    width: 32,
    height: 32,
    transform: "translate(-49 7.688)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ico_pie_chart-2",
    "data-name": "Ico_pie_chart",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54005",
    "data-name": "Path 54005",
    d: "M12.147,0V12.071L1.055,7.3A11.977,11.977,0,0,1,12.147,0Z",
    transform: "translate(-47.075 11.545)",
    fill: "#be88f3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54008",
    "data-name": "Path 54008",
    d: "M16,0A12.071,12.071,0,0,1,28.071,12.071H16Z",
    transform: "translate(-49.071 9.688)",
    fill: "#36adfc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54007",
    "data-name": "Path 54007",
    d: "M12.228,13H24.3A12.072,12.072,0,0,1,2.2,19.715Z",
    transform: "translate(-47.157 10.616)",
    fill: "#06c270"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54006",
    "data-name": "Path 54006",
    d: "M12.071,12.634,2,19.29a11.8,11.8,0,0,1-2-6.657A13.251,13.251,0,0,1,1,7.869Z",
    transform: "translate(-47 10.983)",
    fill: "#00cfde"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPieChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_pie_chart.1487dbe390eb06c7fdb8d27f835ab513.svg";